module.exports = __webpack_public_path__ + "img/89cd271.jpg";